import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';

const ForgotForm = forwardRef(function (props, ref) {
  const { onSubmit } = props;
  const { register, handleSubmit, formState } = useForm({
    defaultValues: {
      email: '',
    },
  });

  useImperativeHandle(ref, () => ({
    handleSubmitForm: () => {
      handleSubmit((data) =>
        onSubmit({
          email: data.email,
        })
      )();
    },
  }));

  return (
    <form>
      <FormControl error={!!formState.errors.email} margin='normal' variant='outlined' fullWidth>
        <InputLabel htmlFor='outlined-username'>Электронная почта</InputLabel>
        <OutlinedInput
          id='outlined-email'
          label='Электронная почта'
          variant='outlined'
          fullWidth
          placeholder='Введите свою электронную почту'
          {...register('email', {
            required: true,
            pattern: /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/,
          })}
        />
      </FormControl>
    </form>
  );
});

export default ForgotForm;
